import { Component, OnInit, AfterViewInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { GoldenLayoutService } from "../golden-layout/golden-layout-service";
import { DashboardMenuItem } from "../bfx-common/models/dashboard-menu-item";
import { DashboardItemType } from "../bfx-common/models/dashboard-item-type.enum";
import { BfxDashboardMenuService } from "../bfx-common/services/bfx-dashboard-menu.service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-dashboard-menu",
  templateUrl: "./html/bfx-dashboard-menu.component.html",
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BfxDashboardMenuComponent implements OnInit {
  menuItems: DashboardMenuItem[];
  hasMenuItems: boolean = false;

  constructor(
    private goldenLayoutService: GoldenLayoutService,
    private dashboardMenuService: BfxDashboardMenuService,
  ) {}

  ngOnInit() {
    this.dashboardMenuService.getMenuProvider().then((values) => {
      if (values.length > 0) {
        this.menuItems = values;
        this.hasMenuItems = true;
      }
    });
  }

  toggle(menu: any, $event: any): any {
    if (this.hasMenuItems) {
      menu.toggle($event);
    }
  }
}
